import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /** Disables the filter's interactive controls. */
  disabled: booleanAttribute(),
  modelValue: {
    type: [String, Number, Boolean, Object, Array],
    default: undefined,
  },
  label: {
    type: String,
    default: "Specialty",
  },
  /**
   * The activator glyph. `service-filled` is the generic specialty/service icon
   * the common-specialty rows already use server-side.
   */
  prependIcon: {
    type: String,
    default: "service-filled",
  },
  appendIcon: {
    type: String,
    default: "popup-arrow-filled",
  },
  /**
   * The doctor-finder embed uuid, used to read the correct shared omnisearch
   * store instance (one fetch per embed). Defaults to the shared store.
   */
  uuid: {
    type: String,
    default: undefined,
  },
  /**
   * Hide the search field at the top of the list.
   *
   * @type {Boolean|String}
   */
  hideSearchBar: booleanAttribute(),
  /**
   * Hide the title bar at the top of the list.
   *
   * @type {Boolean|String}
   */
  hideTitleBar: booleanAttribute(),
  /**
   * Hide the pointer that joins the menu to its activator.
   *
   * @type {Boolean|String}
   */
  hidePointer: booleanAttribute(),
  /** @type {Boolean|String} */
  open: booleanAttribute(),
  location: {
    type: String,
    default: undefined,
  },
  /**
   * Size the filter to its content instead of filling its container.
   *
   * @type {Boolean|String}
   */
  inline: booleanAttribute(),
  /**
   * Close the menu after an option is picked.
   *
   * @type {Boolean|String}
   */
  closeOnSelect: booleanAttribute(),
  /**
   * Show the options without letting the visitor pick one.
   *
   * @type {Boolean|String}
   */
  readonly: booleanAttribute(),
  maxResults: {
    type: [Number, String],
    default: 50,
  },
});
